import type { FaireProductEntity } from "../../entity_types/product";

export const p_aa4wk2da8e: FaireProductEntity = {
  token: "p_aa4wk2da8e",
  type: "product",
  name: "Camo New York Lounge Set",
  brandToken: "b_aq493fxbj4",
  brandName: "Fancy Shmancy Baby",
  imageUrl:
    "https://cdn.faire.com/fastly/bbc67921cdf34055595df380690b849925f476864ddeacd820a5ffe521e76234.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/95349d8e18dd9c155ec3a0bf8fc38f3184e3c5d6f8a4c05130095c05e6250a39.jpeg",
  ],
  priceDollars: 26.5,
  description:
    "Drop shoulder, french terry lounge set in a gray tone camo print. The top is a 3/4 zip, mock neck with gathered cuffs & a bungee cord hem to adjust to your liking. The neon detail on the embroidered NEW YORK print matches the bungee, zip pull & drawstring on the pants. The pants are a loose fit with cargo style pockets on the sides & front hip. The bottom hem is gathered. This has been our most popular set in store & is now available online & ready to ship in 1-3 business days.",
  tags: [],
  msrpDollars: 53,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:59.404Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
